import { Component } from "@angular/core";
import { Injectable, OnInit, Inject } from "@angular/core";
import {
  NavController,
  LoadingController,
  AlertController,
  NavParams
} from "ionic-angular";
import { AuthService } from "../../app/services/auth.service";
import { ENV_VARS } from "../../app/environment-variables/environment-variables.module";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Loading } from "ionic-angular/components/loading/loading";
import { TranslateService } from "@ngx-translate/core";
import { FrontPage } from "../front.page/front.page";
import { HomePage } from "../home.page/home.page";

@Component({
  selector: "two-factor-pin-page",
  templateUrl: "two-factor-pin.page.html"
})
export class TwoFactorPinPage implements OnInit {
  twofactorToken: string;
  messagingMethod: string;
  codeDestinationOptions: {
    title: string;
    value: string;
  }[];
  codeDestination: string;
  loadingOptions: {
    dismissOnPageChange: boolean;
    content: string;
  };
  loading: Loading;
  loginForm: FormGroup;
  sending: boolean = false;
  i18n: { [key: string]: string } = {};
  constructor(
    private authService: AuthService,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private fb: FormBuilder,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public translate: TranslateService,
    @Inject(ENV_VARS) public envVars
  ) {
    this.loginForm = this.fb.group({
      otp: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4)
        ])
      ]
    });
  }

  geti18n() {
    this.translate
      .get([
        "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.HEADER",
        "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.CANCEL_BUTTON",
        "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.CONFIRM_BUTTON",
        "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.MESSAGE",
        "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.MESSAGE_METHOD.MOBILE_PHONE",
        "TWO_FACTOR_PIN_PAGE.WRONG_PIN_ALERT.HEADER",
        "TWO_FACTOR_PIN_PAGE.WRONG_PIN_ALERT.MESSAGE"
      ])
      .subscribe(translations => {
        this.i18n = translations;
      });
  }

  ngOnInit() {
    this.geti18n();
    this.twofactorToken = this.navParams.get("twofactor_token");
    this.messagingMethod = this.navParams.get("used_messaging_method");
    this.codeDestinationOptions = this.navParams.get(
      "messaging_methods_options"
    );
    const usedDestinationOption = this.codeDestinationOptions.find(
      elem => elem.value === this.messagingMethod
    ) || { title: "", value: "" };
    this.codeDestination = usedDestinationOption.title
      .replace("mobile phone", "")
      .replace("email", "");

    this.loadingOptions = {
      dismissOnPageChange: true,
      content: this.translate.instant("GENERIC_UI.LOGGING_IN_MSG")
    };
  }

  chooseResendMethod() {
    let alert = this.alertCtrl.create();
    alert.setTitle(this.i18n["TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.HEADER"]);
    alert.setMessage(this.i18n["TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.MESSAGE"]);
    this.codeDestinationOptions.forEach(opt => {
      let label = opt.title;
      if (label.includes("mobile phone")) {
        label = label.replace(
          "mobile phone",
          this.i18n[
            "TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.MESSAGE_METHOD.MOBILE_PHONE"
          ]
        );
      }
      alert.addInput({
        type: "radio",
        label: label,
        value: opt.value,
        checked: opt.value === this.messagingMethod
      });
    });
    alert.addButton(
      this.i18n["TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.CANCEL_BUTTON"]
    );
    alert.addButton({
      text: this.i18n["TWO_FACTOR_PIN_PAGE.RESEND_PIN_ALERT.CONFIRM_BUTTON"],
      handler: data => {
        this.messagingMethod = data;
        const usedDestinationOption = this.codeDestinationOptions.find(
          elem => elem.value === this.messagingMethod
        ) || { title: "", value: "" };
        this.codeDestination = usedDestinationOption.title
          .replace("mobile phone", "")
          .replace("email", "");
        this.pinResend();
      }
    });
    alert.present();
  }

  pinResend() {
    this.sending = true;
    this.authService
      .otpResend(this.twofactorToken, this.messagingMethod)
      .subscribe((res: any) => {
        this.twofactorToken = res.twofactor_token;
        this.sending = false;
      });
  }

  login() {
    this.loading = this.loadingCtrl.create(this.loadingOptions);
    this.loading.present();
    this.authService
      .twoFactorVerification(
        this.loginForm.controls["otp"].value,
        this.twofactorToken,
        this.messagingMethod,
        "Practitioner"
      )
      .subscribe(res => {}, this.showLoginError.bind(this));
  }

  showLoginError(msg) {
    this.loading.dismiss();
    this.loading = this.loadingCtrl.create(this.loadingOptions); // We have to reset this.loading as it has been dismissed;
    const prompt = this.alertCtrl.create({
      title: this.i18n["TWO_FACTOR_PIN_PAGE.WRONG_PIN_ALERT.HEADER"],
      message: this.i18n["TWO_FACTOR_PIN_PAGE.WRONG_PIN_ALERT.MESSAGE"],
      buttons: ["OK"]
    });
    prompt.present();
  }

  toFrontPage() {
    this.navCtrl.setRoot(FrontPage);
  }

  ionViewWillEnter() {
    if (this.authService.jwt !== null) {
      this.navCtrl.setRoot(HomePage);
    }
  }

  isFormValid() {
    return this.loginForm.valid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/two-factor-pin.page/two-factor-pin.page.ts